import { useTranslation } from "react-i18next";
import type { Sex, UnitsPreference } from "@heraion/shared";
import { HomeMeasurementsWidget, type UiTheme } from "@heraion/ui";

import { useMeasurementsWeb } from "./useMeasurementsWeb";

// HR-11: the measurements Home widget on web. Mounted by HomeView only while
// the widget is on, so the list is read only then. Sex and units come from
// the profile doc the Home already holds (each useProfileDoc() is a GET).
// Twin of apps/mobile/src/screens/HomeMeasurementsCard.tsx.
export function HomeMeasurementsCard({
  theme,
  sex,
  units,
}: {
  theme: UiTheme;
  sex: Sex | undefined;
  units: UnitsPreference;
}) {
  const { i18n } = useTranslation();
  const { items, loading } = useMeasurementsWeb();
  return (
    <HomeMeasurementsWidget
      theme={theme}
      items={items}
      loading={loading}
      sex={sex}
      units={units}
      locale={i18n.language}
    />
  );
}
